import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  &:hover {\n    background: ', ';\n  }\n'], ['\n  &:hover {\n    background: ', ';\n  }\n']);

import styled from 'styled-components';
import { row } from '../theme';

export var TableBodyRow = styled.tr(_templateObject, row.hoverBackground);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/dynamic-table/dist/esm/styled/TableRow.js
// module id = 386
// module chunks = 0